import { useContext } from "react";

import { Outlet, useLocation, useNavigate } from "react-router-dom";

// import { Permissions } from "../../helpers/Permissions";

// import { RoutesEnum } from "../../helpers/Routes";

// import { UserContext } from "../../userContext";

// import { APP_Config } from "../../utils/App_configUtil";

// import Loading from "../Shared/Loading";
import { APP_Config } from "../../utils/AppConfig";
import { RoutesEnum } from "../../utils/RoutesUtil";
import { BankUserContext } from "../../bankUserContext";

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const location = useLocation();
  const userContextData = useContext(BankUserContext);
  /* If token is not available then check for authorization */
  if (token === null) {
    window.location.href = `${
      APP_Config().REACT_APP_BASE_URL
    }authorization/authorize?clientId=${APP_Config().REACT_APP_CLIENT_ID}`;
  } else {
    if (userContextData?.bankuserDetails && userContextData?.bankRolesData) {
      if (location?.pathname) {
        const permissionVailable = userContextData?.bankRolesData?.resources?.find(
          (each) => location?.pathname === RoutesEnum.BASIC ? RoutesEnum.LANDING?.match(each) : location?.pathname?.match(each)
        );

       

        if (permissionVailable) return <Outlet />;
        else {
          window.location.href = `/${RoutesEnum.UNAUTHORIZED}`;
          // return <Outlet />
        }
      } else {
        return <></>;
      }
    }
    return <></>;
  }

  //   if (location.pathname) {
  //      /* Check if location path is in the permissions */
  //     const permissionVailable = Permissions.find((each) =>
  //       location.pathname?.match(each?.path)
  //     );

  //     if (permissionVailable) {
  //         /* Check if location path can be accessed by the user (based on user's role) */
  //       const valid = permissionVailable.permissions.some((each) =>
  //         userContextData?.userDetails?.roles?.includes(each)
  //       );

  //       if (valid) {
  //         return <Outlet />;
  //       } else {
  //           /* Users does not have access then redirect to un authorized */
  //         navigate(`/${RoutesEnum.UNAUTHORIZED}`);
  //       }
  //     } else {
  //       navigate(`/${RoutesEnum.NOTFOUND}`);
  //     }
  //   } else {
  //     navigate(`/${RoutesEnum.NOTFOUND}`);
  //   }

  return <></>;
};

export default ProtectedRoute;
